import objectMatcher from "./objectMatcher";
import { OrganizerComplexFight, UpcomingPublicFight } from "./Fights/types";

export default {
    filter(finishedFights: OrganizerComplexFight[], searchQuery: string): OrganizerComplexFight[] {
        return finishedFights.filter(fight => {
            const fightAsText = [
                fight.category,
                `${fight.firstCompetitor.firstName} ${fight.firstCompetitor.lastName} ${fight.firstCompetitor.academy} ${fight.firstCompetitor.branch}`,
                `${fight.secondCompetitor.firstName} ${fight.secondCompetitor.lastName} ${fight.secondCompetitor.academy} ${fight.secondCompetitor.branch}`,
            ]
                .join(" ")
                .toLocaleLowerCase();
            return objectMatcher.matchString(searchQuery, fightAsText);
        });
    },
    filterPublicFight(publicFight: UpcomingPublicFight, searchQuery: string): boolean {
        const fight = publicFight;
        const fightAsText = [
            fight.category,
            `${fight.firstCompetitor.firstName} ${fight.firstCompetitor.lastName} ${fight.firstCompetitor.academy} ${fight.firstCompetitor.branch}`,
            `${fight.secondCompetitor.firstName} ${fight.secondCompetitor.lastName} ${fight.secondCompetitor.academy} ${fight.secondCompetitor.branch}`,
        ]
            .join(" ")
            .toLocaleLowerCase();

        return objectMatcher.matchString(searchQuery, fightAsText);
    },
};
